// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/inspector/index.scss
// module id = 1078
// module chunks = 0